module.exports = __webpack_public_path__ + "static/img/Lxzk2300.4d5696eb.png";